import React from "react";

export const LocalStorageKeys = {
  accepted_terms: 'accepted_terms',
  tooltip_intro: 'tooltip_intro',
  notification_sound: 'notification_sound',
  chat_cdf: 'chat_cdf',
  chat_chef: 'chat_chef',
  chat_top: 'chat_top',
};
export const DefaultValues = {
  notification_sound: true,
}
const DescriptionKeys = [
  LocalStorageKeys.tooltip_intro,
  LocalStorageKeys.chat_cdf,
  LocalStorageKeys.chat_chef,
  LocalStorageKeys.chat_top,
];


/**
 * React Hook that acts like 'useState', but persists the keys in localstorage
 * From: https://dev.to/selbekk/persisting-your-react-state-in-9-lines-of-code-9go
 */
export function usePersistedState(key, defaultValue) {
  const [state, setState] = React.useState(() => getPersistedState(key, defaultValue));
  React.useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);
  return [state, setState];
}

export const getPersistedState = (key, defaultValue) => {
  const storedValue = JSON.parse(localStorage.getItem(key));
  return storedValue === null ? defaultValue : storedValue;
}

export const clearSomePersistedState = () => Object.values(LocalStorageKeys)
  .filter(key => key !== LocalStorageKeys.accepted_terms)
  .forEach(key => localStorage.removeItem(key));

export const hasClosedDescriptions = () =>
  DescriptionKeys.filter(key => localStorage.getItem(key) === 'true').length > 0;

// convenience accessors
export const notificationSoundOn = () => getPersistedState(LocalStorageKeys.notification_sound, DefaultValues.notification_sound);
